import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";

export default function DetailPair({
  label,
  value,
  link,
  onClick,
  edit,
  loading,
  classes,
  inputOptions,
}) {
  const { navigate } = useContext(UtilityContext);

  const clickHandler = (e) => {
    if (!edit && onClick) onClick(value);
    if (!edit && link) navigate(link, e);
  };

  const classNames = () => {
    let classes = "";
    if (link || onClick)
      classes += " cursor-pointer hover:opacity-70";
    return classes;
  };

  if (!inputOptions) inputOptions = { id: label.toLowerCase() };
  else if (!inputOptions?.id && !inputOptions?.name) inputOptions.id = label.toLowerCase();
  else if (!inputOptions?.name) inputOptions.name = inputOptions.id
  else if (!inputOptions?.id) inputOptions.id = inputOptions.name

  if (loading)
    return (
      <div className="grid w-3/4 gap-1">
        <div className="w-1/3 h-4 rounded animate-pulse bg-stone-700"></div>
        <div className="h-6 rounded animate-pulse bg-stone-600"></div>
      </div>
    );

  return (
    <div onClick={clickHandler} className={classNames()}>
      <p className="text-stone-400">{label}:</p>
      {!edit && <p className={classes || "text-stone-200"}>{value || "-"}</p>}
      {edit && (
        <input
          className={`w-full ${
            inputOptions?.disabled ? "form-input-disabled" : "form-input"
          }`}
          defaultValue={!inputOptions?.disabled ? value : ""}
          autoComplete="off"
          {...inputOptions}
          auto
        />
      )}
    </div>
  );
}
